import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'
import InvoicePayments from "@/modules/finance/invoice-payments/InvoicePayments";

let routes = [{
  path: 'invoice-payments',
  name: 'invoicesPayments',
  component: InvoicePayments,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/invoice-payments', i18n.t('Invoice Payments'), 40, 'wallet', [], 'view_invoice'),
  routes: routes
}
